export enum HqPackingListType {
    DELIVERY_NOTE = "delivery_note",
    FACTORY_LOADING_PLAN = "factory_loading_plan"
}